module.exports = __webpack_public_path__ + "img/github.a2e678a3.svg";